import { LogDrainIntegration } from "@modules/graphql/types"
import { logDrainConfigRequiredFields } from "./constants"

export const isProperlyConnected = (integration: LogDrainIntegration) => {
  if (!integration.config) {
    return false
  }

  return logDrainConfigRequiredFields[
    integration.logDrainProvider
  ].every((requiredConfigKey: string) =>
    Boolean(integration.config[requiredConfigKey])
  )
}
